import React, { useState } from 'react';
import './CalendarDay.css';

// Country code to color mapping for holiday indicators
const COUNTRY_COLORS = {
  US: '#3B82F6', // Blue
  DO: '#EF4444', // Red
  TN: '#10B981', // Green
  CO: '#F59E0B', // Amber
  VE: '#8B5CF6', // Purple
  AR: '#06B6D4', // Cyan
  PT: '#EC4899', // Pink
};

function CalendarDay({ day, dateStr, isToday, isWeekend, holidays, timeOff, userCountryId }) {
  const [showTooltip, setShowTooltip] = useState(false);

  const hasHolidays = holidays.length > 0;
  const hasTimeOff = timeOff.length > 0;
  const hasEvents = hasHolidays || hasTimeOff;

  // Check if any holiday is for the user's country
  const isUserHoliday = holidays.some(h => h.country_id === userCountryId);

  const classNames = [
    'calendar-day',
    isToday ? 'today' : '',
    isWeekend ? 'weekend' : '',
    isUserHoliday ? 'user-holiday' : '',
  ].filter(Boolean).join(' ');

  return (
    <div
      className={classNames}
      onMouseEnter={() => hasEvents && setShowTooltip(true)}
      onMouseLeave={() => setShowTooltip(false)}
    >
      <span className={`day-number ${isToday ? 'today-badge' : ''}`}>
        {day}
      </span>

      <div className="day-events">
        {holidays.slice(0, 2).map((h, i) => (
          <div
            key={`h-${i}`}
            className="day-event holiday-event"
            style={{ borderLeftColor: COUNTRY_COLORS[h.country_code] || '#6B7280' }}
          >
            <span className="event-label">{h.name}</span>
          </div>
        ))}
        {timeOff.slice(0, 2).map((t, i) => (
          <div
            key={`t-${i}`}
            className={`day-event timeoff-event ${t.status}`}
          >
            <span className="event-label">{t.user_name}</span>
          </div>
        ))}
        {(holidays.length + timeOff.length) > 4 && (
          <div className="day-event-overflow">
            +{holidays.length + timeOff.length - 4} more
          </div>
        )}
      </div>

      {showTooltip && hasEvents && (
        <div className="day-tooltip">
          {holidays.map((h, i) => (
            <div key={`th-${i}`} className="tooltip-item tooltip-holiday">
              <span
                className="tooltip-dot"
                style={{ background: COUNTRY_COLORS[h.country_code] || '#6B7280' }}
              />
              <div className="tooltip-content">
                <span className="tooltip-name">{h.name}</span>
                <span className="tooltip-meta">{h.country_name}</span>
              </div>
            </div>
          ))}
          {timeOff.map((t, i) => (
            <div key={`tt-${i}`} className="tooltip-item tooltip-timeoff">
              <span
                className="tooltip-dot"
                style={{ background: t.status === 'approved' ? '#10B981' : '#F59E0B' }}
              />
              <div className="tooltip-content">
                <span className="tooltip-name">{t.user_name}</span>
                <span className="tooltip-meta">{t.status === 'approved' ? 'Approved' : 'Pending'}</span>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}

export default CalendarDay;
